import { WithBi } from '../bi';
export var withBiLogger = function (component) { return WithBi(component); };
//# sourceMappingURL=with-bi-logger.js.map